
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.18 12.76h11.17l-4.88 4.88a1.008 1.008 0 000 1.42 1 1 0 001.41 0l6.59-6.59a1 1 0 000-1.41l-6.59-6.59a1 1 0 00-1.41 1.41l4.88 4.88H5.18a1 1 0 000 2z"}})])
          )
        }
      }
    